

exports.__esModule = true;
exports.$ShoppingCartModel = undefined;

var _squid = require('squid');

var $ShoppingCartModel = exports.$ShoppingCartModel = _squid.$Model.extend('$ShoppingCartModel', {
    api: new _squid.$Api({
        uri: '/api/shoppingcart/:id',
        postAttempts: 2,
        cache: false
    })
});

angular.value("$ShoppingCartModel", $ShoppingCartModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/shoppingcart/index.js
// module id = ../node_modules/xo-models/src/shoppingcart/index.js
// module chunks = 0